import React from 'react';
import { FormatTypes } from '../../../../Lib/Format';
import { Field, TextOutput } from '../../../Core';
import { withInjectedProps } from '../../../Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from '../../../Layout';
import { QestlabListDropdown } from '../../../List';
import ListType from '../../../List/QestlabListDropdown/ListType';
import { IWithWorksheetInjectedProps } from '../../Core';

let SoilSamplingDetails: React.FC<IWithWorksheetInjectedProps> = () => {
  return (
    <SectionGroup>
      <ListFieldSection>
        <Field input={<TextOutput />} name="SamplingDetails.ContractorName" />
        <Field
          input={<TextOutput />}
          name="SamplingDetails.DateTimeSampled"
          label={'Date Sampled'}
          format={{ type: FormatTypes.Date }}
        />

        <Field
          input={<TextOutput />}
          name="SamplingDetails.DateTimeSampled"
          label={'Time Sampled'}
          format={{ type: FormatTypes.Time, pattern: 'HH:mm' }}
        />
        <Field input={<TextOutput />} name="SamplingDetails.SampledBy" />

        <Field input={<TextOutput />} name="SamplingDetails.SamplingMethod" />
        <Field input={<TextOutput />} name="SamplingDetails.SamplingType" />

        <Field
          input={<QestlabListDropdown />}
          name="SamplingDetails.Weather"
          listType={ListType.Weather}
          maxLength={50}
        />
        <Field input={<TextOutput />} name="SamplingDetails.SupplierName" />

        <Field input={<TextOutput />} name="SamplingDetails.SourceName" />
        <Field input={<TextOutput />} name="SamplingDetails.Material" />

        <Field input={<TextOutput />} name="SamplingDetails.GeneralLocation" />
        <Field input={<TextOutput />} name="SamplingDetails.Location" />

        <Field input={<TextOutput />} name="SamplingDetails.SamplePickupNotes" />
      </ListFieldSection>
    </SectionGroup>
  );
};

const SoilSamplingDetailsSection = withInjectedProps(SoilSamplingDetails);
export { SoilSamplingDetailsSection };
export default SoilSamplingDetailsSection;
